import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const networkApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
networkApiInstance.interceptors.request.use(requestInterceptor);

export default networkApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/networkApi.js